import { FooterButtonGroup, FooterButton } from "./footer";

export function UndoRedoControls({
  undoEnabled,
  redoEnabled,
  onUndo,
  onRedo,
  onClick,
}: {
  undoEnabled: boolean;
  redoEnabled: boolean;
  onUndo: () => void;
  onRedo: () => void;
  onClick?: () => void;
}) {
  return (
    <>
      <FooterButtonGroup>
        <FooterButton
          tooltip="Undo"
          onClick={() => {
            onClick ? onClick() : onUndo();
          }}
          disabled={!undoEnabled}
        >
          <svg width="22" height="10" viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21 8.2854C20.4652 6.23201 19.2701 4.41142 17.5988 3.10406C15.9275 1.79671 13.8727 1.07512 11.751 1.05046C9.62925 1.02579 7.55825 1.69941 5.85702 2.96756C4.15578 4.23571 2.91869 6.02803 2.3363 8.06843M1.18699 3.39329L1.74322 8.13796L6.48788 7.58174"
              stroke={undoEnabled ? "#0B2642" : "#CBCFD2"}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </FooterButton>
        <FooterButton
          tooltip="Redo"
          onClick={() => {
            onClick ? onClick() : onRedo();
          }}
          disabled={!redoEnabled}
        >
          {" "}
          <svg width="22" height="10" viewBox="0 0 22 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M1 8.2854C1.5348 6.23201 2.72989 4.41142 4.40118 3.10406C6.07248 1.79671 8.12726 1.07512 10.249 1.05046C12.3707 1.02579 14.4417 1.69941 16.143 2.96756C17.8442 4.23571 19.0813 6.02803 19.6637 8.06843M20.813 3.39329L20.2568 8.13796L15.5121 7.58174"
              stroke={redoEnabled ? "#0B2642" : "#CBCFD2"}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </FooterButton>
      </FooterButtonGroup>
    </>
  );
}
